import { createSlice } from "@reduxjs/toolkit";

import {
  addClientDirectoryAction,
  addLeadCommentsAction,
  changeClientStatusAction,
  clientAadharUniqueCheckAction,
  clientPanUniqueCheckAction,
  getClientDirectoryLeadListAction,
  getClientDirectoryLeadStageCountAction,
  getClientDirectoryListAction,
  getLeadCommentsDetailsAction,
  getSingleClientDirectoryAction,
  getSingleClientDirectoryLeadDetailsAction,
  leadHistoryAction,
  leadSentEmailAction,
  leadClientSentEmailHistoryAction,
  updateClientDirectoryAction,
  updateClientDirectoryLeadDetailsAction,
  clientSentEmailAction,
  updateClientMeetUpChecklistAction,
  getClientMeetUpChecklistAction,
  getSingleClientMeetUpChecklistAction,
  addLeadRecordingAction,
  getLeadRecordingDetailsAction,
  getCityListAction,
  updateLeadStatusAction,
  getStageListAction,
  updateLeadStageAction,
  getClientDirectorySortByThresholdLeadListAction,
  getClientDirectoryLeadStageSortByStageCountAction,
} from "@/redux/clientDirectory/action";
import type { ClientDirectoryType } from "@/redux/clientDirectory/clientDirectoryType";
import { initialState } from "@/redux/clientDirectory/initialState";
import { clientDirectoryReducer } from "@/redux/clientDirectory/reducer";

export const clientDirectorySlice = createSlice({
  name: "clientDirectory",
  initialState,
  reducers: clientDirectoryReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getClientDirectoryListAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientDirectoryListAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          clientDirectoryList: result?.data,
          totalCount: result?.total_count,
        };
      }
    );

    builder.addCase(
      getClientDirectoryListAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSingleClientDirectoryAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleClientDirectoryAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          // success,
          singleClientDirectory: result,
        };
      }
    );

    builder.addCase(
      getSingleClientDirectoryAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      updateClientDirectoryAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateClientDirectoryAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload?.data || {};
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      updateClientDirectoryAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      changeClientStatusAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      changeClientStatusAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload?.data || {};
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            clientStatusSuccess: success,
          };
        }
        return {
          ...state,
          fetching: false,
          clientStatusSuccess: success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      changeClientStatusAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        clientStatusSuccess: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      updateLeadStatusAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
      })
    );

    builder.addCase(
      updateLeadStatusAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          success: success,
          statusCode: status_code,
          message,
        };
      }
    );

    builder.addCase(
      updateLeadStatusAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      updateLeadStageAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateLeadStageAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            error: message,
            statusCode: status_code,
            success,
            fetching: false,
          };
        }
        return {
          ...state,
          success: success,
          statusCode: status_code,
          fetching: false,
          message,
        };
      }
    );

    builder.addCase(
      updateLeadStageAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getStageListAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getStageListAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        // const { data } = payload;
        const { success, message, status_code, result, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          leadStageList: result,
          leadStageTotal: total_count,
        };
      }
    );

    builder.addCase(
      getStageListAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      addClientDirectoryAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      addClientDirectoryAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload?.data || {};
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      addClientDirectoryAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      clientAadharUniqueCheckAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        clientAadharUniqueCheckFetching: true,
      })
    );

    builder.addCase(
      clientAadharUniqueCheckAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            clientAadharUniqueCheckFetching: false,
            clientAadharUniqueCheckError: message,
            statusCode: status_code,
            clientAadharUniqueCheckSuccess: success,
          };
        }
        return {
          ...state,
          clientAadharUniqueCheckMessage: message,
          clientAadharUniqueCheckFetching: false,
          clientAadharUniqueCheckSuccess: success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      clientAadharUniqueCheckAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        clientAadharUniqueCheckFetching: false,
        clientAadharUniqueCheckSuccess: 0,
        clientAadharUniqueCheckError: error.message ?? null,
      })
    );

    builder.addCase(
      clientPanUniqueCheckAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        clientPanUniqueCheckFetching: true,
      })
    );

    builder.addCase(
      clientPanUniqueCheckAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            clientPanUniqueCheckFetching: false,
            clientPanUniqueCheckError: message,
            statusCode: status_code,
            clientPanUniqueCheckSuccess: success,
          };
        }
        return {
          ...state,
          clientPanUniqueCheckFetching: false,
          clientPanUniqueCheckSuccess: success,
          clientPanUniqueCheckMessage: message,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      clientPanUniqueCheckAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        clientPanUniqueCheckFetching: false,
        clientPanUniqueCheckSuccess: 0,
        clientPanUniqueCheckError: error.message ?? null,
      })
    );

    builder.addCase(
      getClientDirectoryLeadListAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientDirectoryLeadListAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result, total_count } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          leadDirectoryList: result,
          leadDirectoryTotal: total_count,
        };
      }
    );

    builder.addCase(
      getClientDirectoryLeadListAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getClientDirectorySortByThresholdLeadListAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientDirectorySortByThresholdLeadListAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result, total_count } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          leadDirectoryList: result,
          leadDirectoryTotal: total_count,
        };
      }
    );

    builder.addCase(
      getClientDirectorySortByThresholdLeadListAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getClientDirectoryLeadStageCountAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientDirectoryLeadStageCountAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result, total_count } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          leadStageCount: result,
        };
      }
    );

    builder.addCase(
      getClientDirectoryLeadStageCountAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getClientDirectoryLeadStageSortByStageCountAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientDirectoryLeadStageSortByStageCountAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result, total_count } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          leadStageCount: result,
        };
      }
    );

    builder.addCase(
      getClientDirectoryLeadStageSortByStageCountAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSingleClientDirectoryLeadDetailsAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleClientDirectoryLeadDetailsAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code, result } = data;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }

        return {
          ...state,
          fetching: false,
          // success,
          singleClientleadDirectoryDetails: result,
        };
      }
    );

    builder.addCase(
      getSingleClientDirectoryLeadDetailsAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      updateClientDirectoryLeadDetailsAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateClientDirectoryLeadDetailsAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
        };
      }
    );

    builder.addCase(
      getLeadCommentsDetailsAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        leadDirectoryCommentsFetching: true,
      })
    );

    builder.addCase(
      getLeadCommentsDetailsAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        //    const {data}=payload;
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            leadDirectoryCommentsFetching: false,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          leadDirectoryCommentsFetching: false,
          // success:success,
          leadDirectoryCommentsList: result,
          statusCode: status_code,
          // leadDirectoryTotal:total_count
        };
      }
    );

    builder.addCase(
      getLeadCommentsDetailsAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        leadDirectoryCommentsFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getCityListAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        cityFetching: true,
      })
    );

    builder.addCase(
      getCityListAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        //    const {data}=payload;
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            cityFetching: false,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          cityFetching: false,
          // success:success,
          uniqueCityList: result?.data,
          uniqueCityCount: result?.total_count,
          statusCode: status_code,
          // leadDirectoryTotal:total_count
        };
      }
    );

    builder.addCase(
      getCityListAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        cityFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getLeadRecordingDetailsAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        leadDirectoryRecordingsFetching: true,
      })
    );

    builder.addCase(
      getLeadRecordingDetailsAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        //    const {data}=payload;
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            leadDirectoryRecordingsFetching: false,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          leadDirectoryRecordingsFetching: false,
          leadDirectoryRecordingsList: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getLeadRecordingDetailsAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        leadDirectoryRecordingsFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      addLeadCommentsAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        leadDirectoryCommentsFetching: true,
      })
    );

    builder.addCase(
      addLeadCommentsAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            leadDirectoryCommentsFetching: false,
            error: message,
            statusCode: status_code,
            leadDirectoryCommentsSuccess: success,
          };
        }
        return {
          ...state,
          leadDirectoryCommentsFetching: false,
          leadDirectoryCommentsSuccess: success,
          statusCode: status_code,
          responsiblePeople: result,
        };
      }
    );

    builder.addCase(
      addLeadCommentsAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        leadDirectoryCommentsFetching: false,
        leadDirectoryCommentsSuccess: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      addLeadRecordingAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        leadDirectoryRecordingsFetching: true,
      })
    );

    builder.addCase(
      addLeadRecordingAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            leadDirectoryRecordingsFetching: false,
            error: message,
            statusCode: status_code,
            leadDirectoryRecordingsSuccess: success,
          };
        }
        return {
          ...state,
          leadDirectoryRecordingsFetching: false,
          leadDirectoryRecordingsSuccess: success,
          statusCode: status_code,
          responsiblePeople: result,
        };
      }
    );

    builder.addCase(
      addLeadRecordingAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        leadDirectoryRecordingsFetching: false,
        leadDirectoryRecordingsSuccess: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      leadSentEmailAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        emailFetching: true,
      })
    );

    builder.addCase(
      leadSentEmailAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            emailFetching: false,
            error: message,
            statusCode: status_code,
            success: 0,
          };
        }
        return {
          ...state,
          message,
          statusCode: status_code,
          success,
          emailFetching: false,
        };
      }
    );

    builder.addCase(
      leadSentEmailAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        emailFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      clientSentEmailAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        emailFetching: true,
      })
    );

    builder.addCase(
      clientSentEmailAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            emailFetching: false,
            error: message,
            statusCode: status_code,
            success: 0,
          };
        }
        return {
          ...state,
          message,
          statusCode: status_code,
          success,
          emailFetching: false,
        };
      }
    );

    builder.addCase(
      clientSentEmailAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        emailFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      leadHistoryAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        leadFetching: true,
      })
    );

    builder.addCase(
      leadHistoryAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            leadFetching: false,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          leadFetching: false,
          leadHistory: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      leadHistoryAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        leadFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      leadClientSentEmailHistoryAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        emailFetching: true,
      })
    );

    builder.addCase(
      leadClientSentEmailHistoryAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            emailFetching: false,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          emailFetching: false,
          leadClientEmailHistory: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      leadClientSentEmailHistoryAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        emailFetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      updateClientDirectoryLeadDetailsAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      updateClientMeetUpChecklistAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateClientMeetUpChecklistAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { data } = payload;
        const { success, message, status_code } = data;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          success,
          message,
        };
      }
    );

    builder.addCase(
      updateClientMeetUpChecklistAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getClientMeetUpChecklistAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getClientMeetUpChecklistAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code, result, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            client: false,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          fetching: false,
          clientMeetUpChecklistData: result,
          statusCode: status_code,
          totalCount: total_count,
        };
      }
    );

    builder.addCase(
      getClientMeetUpChecklistAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );

    builder.addCase(
      getSingleClientMeetUpChecklistAction.pending,
      (state: ClientDirectoryType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleClientMeetUpChecklistAction.fulfilled,
      (state: ClientDirectoryType, { payload }) => {
        const { success, message, status_code, result } = payload;
        if (success === 0) {
          return {
            ...state,
            client: false,
            error: message,
            statusCode: status_code,
            success: success,
          };
        }
        return {
          ...state,
          fetching: false,
          singleClientMeetUpChecklistData: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getSingleClientMeetUpChecklistAction.rejected,
      (state: ClientDirectoryType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error.message ?? null,
      })
    );
  },
});
export const {
  resetClientDirectoryError,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetClientDirectoryList,
  resetClientDirectoryFetching,
  resetSingleClientDirectory,
  resetClientDirectoryTotalCount,
  resetClientStatusSuccess,
  resetClientAadharUniqueCheckSuccess,
  resetClientAadharUniqueCheckError,
  resetClientAadharUniqueCheckMessage,
  resetClientPanUniqueCheckSuccess,
  resetClientPanUniqueCheckError,
  resetClientPanUniqueCheckMessage,
  resetLeadDirectoryTotal,
  resetLeadDirectoryList,
  resetSingleClientLeadDirectoryDetails,
  resetLeadModuleCommentsSuccess,
  resetLeadModuleCommentsListing,
  resetLeadDirectoryCommentsFetching,
  resetLeadHistory,
  resetLeadStageCount,
  resetLeadClientEmailHistory,
  resetLeadEmailFetching,
  setPersistLeadDirectory,
  resetLeadModuleRecordingsSuccess,
  resetLeadModuleRecordingsListing,
  resetLeadDirectoryRecordingsFetching,
  resetClientMeetUpChecklistData,
  resetSingleClientMeetUpCheklistData,
  resetUniqueCityList,
  resetUniqueCityCount,
  resetCityFetching,
  resetLeadStageList,
  resetLeadStageTotal,
} = clientDirectorySlice.actions;
